import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=993ca664&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993ca664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('993ca664')) {
      api.createRecord('993ca664', component.options)
    } else {
      api.reload('993ca664', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=993ca664&scoped=true&", function () {
      api.rerender('993ca664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mMR6hz7nidw8/JS/comp/Accordion.vue"
export default component.exports